export default __webpack_public_path__ + "static/media/tessen.7dccf027.png";